import axios from 'axios';
import apiRoutes from '../../apiRoutes';
import * as NotificationsActionCreators from './notificationsActions';

/*
 * action types
 */
export const QUESTION_LOADING = 'QUESTION_LOADING';
export const QUESTION_LOADING_ANSWERS = 'QUESTION_LOADING_ANSWERS';
export const QUESTION_FAILURE = 'QUESTION_FAILURE';
export const GET_QUESTIONS = 'GET_QUESTIONS';
export const GET_QUESTION = 'GET_QUESTION';
export const ADD_QUESTION = 'ADD_QUESTION';
export const EDIT_QUESTION = 'EDIT_QUESTION';
export const REMOVE_QUESTION = 'REMOVE_QUESTION';
export const ENABLE_QUESTION = 'ENABLE_QUESTION';
export const EDIT_QUESTION_IMAGE = 'EDIT_QUESTION_IMAGE';

/*
 * action creators
 */

const loading = () => ({
  type: QUESTION_LOADING,
});

const loadingAnswers = () => ({
  type: QUESTION_LOADING_ANSWERS,
});

const questionFailure = (error) => ({
  type: QUESTION_FAILURE,
  error: error,
});

const successGetQuestions = (questions) => ({
  type: GET_QUESTIONS,
  questions,
});

const successGetQuestion = (question, answers) => ({
  type: GET_QUESTION,
  question,
  answers
});

const successAddQuestion = (question) => ({
  type: ADD_QUESTION,
  question
});

const successEditQuestion = (question) => ({
  type: EDIT_QUESTION,
  question
});

const successRemoveQuestion = (questionId) => ({
  type: REMOVE_QUESTION,
  questionId
});

const successEnableQuestion = (questionId) => ({
  type: ENABLE_QUESTION,
  questionId
});

const successEditQuestionImage = (question) => ({
  type: EDIT_QUESTION_IMAGE,
  question
});

const processQuestion = (question, answers) => ({
  ...question,
  id: question.id || question._id,
  tags: question.tagIds.map((tag) => tag.name || tag).join(', '),
  tagIds: question.tagIds.map((tag) => ({
    id: tag._id || undefined,
    name: tag.name || tag
  })),
  questionTypeText: question.questionType.join(', '),
  answers,
});

export const getQuestions = (token) => (dispatch) => {
  dispatch(loading());
  const config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };
  axios.get(apiRoutes.api.questions, config).then((result) => {
      const questions = result.data.map((question) => processQuestion(question));
      dispatch(successGetQuestions(questions));
  }).catch((error) => {
    console.error('Axios error: ', error);
    dispatch(questionFailure(error));
  });
};

export const getQuestion = (token, questionId, onlyAnswers = false, callback = null) => (dispatch) => {
  if (onlyAnswers) {
   dispatch(loadingAnswers());
  } else {
    dispatch(loading());
  }
  const config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };
  axios.get(apiRoutes.api.questions + "/" + questionId, config)
    .then((questionResponse) => {
      axios.get(apiRoutes.api.questionAnswers + questionId, config)
        .then((answersResponse) => {
          const question = questionResponse.data;
          const answers = answersResponse.data;
          dispatch(successGetQuestion(question, answers));
        }).catch((error) => {
        console.log('Axios error: ', error);
        dispatch(NotificationsActionCreators.addNotification('error', error.response.status, 'Nepodařilo se načíst odpovědi!'));
        dispatch(questionFailure(error));
      });
    }).catch((error) => {
    console.log("Axios error: ", error);
    dispatch(NotificationsActionCreators.addNotification('error', error.response.status, 'Nepodařilo se načíst otázku!'));
    dispatch(questionFailure(error));
  });
};

export const addQuestion = (token, values, callback = null) => (dispatch) => {
  dispatch(loading());
  let config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };
  axios.post(apiRoutes.api.questions, {
    ...values,
  }, config).then((questionResponse) => {
    let answerRequests = [];
    const answers = [];
    values.answers.forEach((answer, index) => {
      let data = {
        text: answer.text,
        correctness: answer.correctness,
        order: index,
        question: questionResponse.data.id
      };
      answerRequests.push(
        axios.post(apiRoutes.api.answers, data, config)
          .then((answerResponse) => {
            const answer = {
              ...answerResponse.data,
              id: answerResponse.data.id || answerResponse.data._id,
            };
            answers.push(answer);
          })
      );
    });
    axios.all(answerRequests).then(() => {
      dispatch(NotificationsActionCreators.addNotification('success', questionResponse.status, 'Otázka č. ' + questionResponse.data.name + ' byla vytvořena.'));
      const question = processQuestion(questionResponse.data, answers);
      dispatch(successAddQuestion(question));
      if (callback) callback();
    }).catch((error) => {
      dispatch(NotificationsActionCreators.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo vytvořit jednu z odpovědí!'));
      console.log("Axios error: ", error);
      dispatch(questionFailure(error));
    });
  }).catch((error) => {
    dispatch(NotificationsActionCreators.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Otázku se nepodařilo vytvořit!'));
    console.log("Axios error: ", error);
    dispatch(questionFailure(error));
  });
};

export const editQuestion = (token, questionId, values, callback = null) => (dispatch) => {
  dispatch(loading());
  let config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };

  let answersToDelete = values.answersToDelete;
  let deleteRequests = [];
  answersToDelete.forEach((answer) => {
    deleteRequests.push(axios.delete(apiRoutes.api.answers + "/" + answer.id, config));
  });
  axios.all(deleteRequests).then(() => {
    let answers = values.answers.map((answer, index) => {
      return ({
        ...answer,
        order: index + 1,
        question: questionId
      });
    });
    const editedAnswers = [];
    let editAnswers = answers.filter((answer) => answer.id);
    let addAnswers = answers.filter((answer) => !answer.id);
    let editRequests = [];
    editAnswers.forEach((answer) => {
      editRequests.push(
        axios.put(apiRoutes.api.answers + "/" + answer.id, {
          text: answer.text,
          order: answer.order,
          correctness: answer.correctness,
          question: questionId
        }, config)
          .then((response) => {
            editedAnswers.push(response.data);
          })
      );
    });
    axios.all(editRequests).then(() => {
      let addRequests = [];
      addAnswers.forEach((answer) => {
        addRequests.push(
          axios.post(apiRoutes.api.answers, answer, config)
            .then((response) => {
              editedAnswers.push(response.data);
            })
        );
      });
      axios.all(addRequests).then(() => {
        axios.put(apiRoutes.api.questions + "/" + questionId, {
            text: values.text,
            explanation: values.explanation,
            paragraph: values.paragraph,
            lawLink: values.lawLink,
            timeframe: values.timeframe,
            pointsValue: values.pointsValue,
            moneyValue: values.moneyValue,
            questionType: values.questionType,
            tagIds: values.tagIds.map(tag => tag.name ? tag.name : tag),
            enabled: values.enabled,
          }
          , config).then((response) => {
            const question = processQuestion(response.data, editedAnswers);
          dispatch(NotificationsActionCreators.addNotification('success', response.status, 'Otázka č. ' + response.data.name + ' byla upravena.'));
          dispatch(successEditQuestion(question));
          if (callback) callback();
        }).catch((error) => {
          console.log("Axios error: ", error);
          dispatch(NotificationsActionCreators.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Otázku se nepodařilo upravit!'));
          dispatch(questionFailure(error));
        });
      }).catch((error) => {
        console.log("Axios error: ", error);
        dispatch(NotificationsActionCreators.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se přidat jednu z odpovědí!'));
        dispatch(questionFailure(error));
      });
    }).catch((error) => {
      console.log("Axios error: ", error);
      dispatch(NotificationsActionCreators.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se upravit jednu z odpovědí!'));
      dispatch(questionFailure(error));
    })
  }).catch((error) => {
    console.log("Axios error: ", error);
    dispatch(NotificationsActionCreators.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se odstranit jednu z odpovědí!'));
    dispatch(questionFailure(error));
  });
};

export const enableQuestion = (token, question) => (dispatch) => {
  const config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };
  axios.put(apiRoutes.api.questions + "/" + question.id, {
    enabled: !question.enabled,
  }, config)
    .then((response) => {
      dispatch(NotificationsActionCreators.addNotification('success', response.status, 'Otázka č. ' + question.name + ' byla ' + (question.enabled ? 'zakázána' : 'povolena') + '.'));
      dispatch(successEnableQuestion(question.id));
    })
    .catch((error) => {
      dispatch(NotificationsActionCreators.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Otázku č. ' + question.name + ' se nepodařilo povolit!'));
      console.log("Axios error: ", error);
      dispatch(questionFailure(error));
    })
};

export const editQuestionImage = (token, values) => (dispatch) => {
  const config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };
  axios.put(apiRoutes.api.questions + "/" + values.id, {
    ...values,
  }, config).then((response) => {
    dispatch(NotificationsActionCreators.addNotification('success', response.status, 'Obrázek otázky byl upraven.'));
    const question = {
      ...response.data,
      id: response.data.id || response.data._id
    };
    dispatch(successEditQuestionImage(question));
  }).catch((error) => {
    dispatch(NotificationsActionCreators.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Obrázek otázky se nepodařilo upravit!'));
    console.log("Axios error: ", error);
    dispatch(questionFailure(error));
  })
};

export const removeQuestion = (token, question, callback = null) => (dispatch) => {
  dispatch(loading());
  let config = {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  };

  axios.get(apiRoutes.api.questionAnswers + question.id, config).then((response) => {
    let deleteRequests = [];
    response.data.forEach((answer) => {
      deleteRequests.push(axios.delete(apiRoutes.api.answers + "/" + answer.id, config));
    });
    axios.all(deleteRequests).then(() => {
      // delete question
      axios.delete(apiRoutes.api.questions + "/" + question.id, config)
        .then((response) => {
          dispatch(NotificationsActionCreators.addNotification('success', response.status, 'Otázka č. ' + question.name + ' byla odstraněna.'));
          dispatch(successRemoveQuestion(question.id));
          if (callback) callback();
        }).catch((error) => {
        console.log("Axios error: ", error);
        dispatch(NotificationsActionCreators.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Otázku č. ' + question.name + ' se nepodařilo odstranit!'));
      });
    }).catch((error) => {
      console.log("Axios error: ", error);
      dispatch(NotificationsActionCreators.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Nepodařilo se odstranit jednu z odpovědí!'));
    })
  }).catch((error) => {
    console.log("Axios error: ", error);
    // delete question
    axios.delete(apiRoutes.api.questions + "/" + question.id, config)
      .then((response) => {
        dispatch(NotificationsActionCreators.addNotification('success', response.status, 'Otázka č. ' + question.name + ' byla odstraněna.'));
        dispatch(successRemoveQuestion(question.id));
        if (callback) callback();
      }).catch((error) => {
      console.log("Axios error: ", error);
      dispatch(NotificationsActionCreators.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Otázku č. ' + question.name + ' se nepodařilo odstranit!'));
    });
  });
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/questionActions.js
 **/